import { Directive, inject, OnInit } from '@angular/core';

import { UaService } from '@ecm/consumer';
import { EnvUtils } from '@ecm/dispatcher';
import { PortfolioFlagsService } from '@ecm/portfolio';

@Directive()
export abstract class AbstractComponent implements OnInit {
    public isMobile: boolean;
    public isEclair: boolean;

    protected readonly uaService = inject(UaService);
    protected readonly portfolioFlagsService = inject(PortfolioFlagsService);

    /**
     * Gets current contract Id from URL
     * Subscribes onContractOpened event
     */
    public ngOnInit(): void {
        this.isEclair = EnvUtils.isEclair();

        this.isMobile = this.uaService.isMobile();
    }

    /**
     * Get current brand flag (Sosh vs Orange) from centralized PortfolioFlagsService
     * This replaces the previous router-based detection (isCurrentRouteSosh).
     * Flags are synced automatically whenever Portfolio is loaded.
     */
    public isSoshBrand(): boolean {
        return this.portfolioFlagsService.isSosh();
    }
}
